<template>
  <dialog :open="open" class="modal" @click.self="$emit('close')">
    <div class="modal-box max-w-md w-full" @click.stop>
      <!-- Header -->
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-semibold">Gemini API Key</h3>
        <button
          @click="$emit('close')"
          class="btn btn-sm btn-circle btn-ghost"
          title="Kapat"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Content -->
      <div class="space-y-4">
        <div class="form-control">
          <label class="label">
            <span class="label-text">API Key</span>
          </label>
          <div class="relative">
            <input
              v-model="apiKey"
              type="password"
              placeholder="Gemini API Key giriniz"
              class="input input-bordered w-full pr-10"
              @keyup.enter="saveApiKey"
            />
            <button
              v-if="apiKey"
              @click="clearApiKey"
              class="absolute right-2 top-1/2 -translate-y-1/2 btn btn-ghost btn-xs btn-circle"
              title="Temizle"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <label class="label">
            <span class="label-text-alt text-base-content/60">
              API Key'iniz store'da güvenli bir şekilde saklanacaktır
            </span>
          </label>
        </div>

        <div class="alert alert-info">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="stroke-current shrink-0 w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span class="text-xs">
            VITE_GEMINI_API_KEY env değişkeni boş ise, burada girilen key kullanılacaktır.
          </span>
        </div>
      </div>

      <!-- Actions -->
      <div class="modal-action">
        <button
          v-if="hasStoredKey"
          @click="clearStoredKey"
          class="btn btn-error btn-outline"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Store'dan Temizle
        </button>
        <button @click="$emit('close')" class="btn btn-ghost">
          İptal
        </button>
        <button @click="saveApiKey" class="btn btn-primary" :disabled="!apiKey.trim()">
          Kaydet
        </button>
      </div>
    </div>
    <!-- Backdrop -->
    <form method="dialog" class="modal-backdrop" @click="$emit('close')">
      <button>close</button>
    </form>
  </dialog>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { getCurrentInstance } from 'vue';

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'save']);

const app = getCurrentInstance();
const store = app.appContext.config.globalProperties.$store;

const apiKey = ref('');
const hasStoredKey = ref(false);

// Store'dan mevcut key'i yükle
const loadApiKey = () => {
  const storedKey = store.getters._getGeminiApiKey;
  hasStoredKey.value = !!storedKey;
  if (storedKey) {
    apiKey.value = storedKey;
  } else {
    apiKey.value = '';
  }
};

// Modal açıldığında key'i yükle
watch(() => props.open, (newVal) => {
  if (newVal) {
    loadApiKey();
  }
});

onMounted(() => {
  loadApiKey();
});

const saveApiKey = () => {
  if (apiKey.value.trim()) {
    store.commit('setGeminiApiKey', apiKey.value.trim());
    hasStoredKey.value = true;
    emit('save', apiKey.value.trim());
    emit('close');
  }
};

// Input alanındaki key'i temizle (sadece input'tan)
const clearApiKey = () => {
  apiKey.value = '';
};

// Store'daki key'i temizle
const clearStoredKey = () => {
  if (confirm('Store\'daki API Key\'i temizlemek istediğinize emin misiniz?')) {
    store.commit('setGeminiApiKey', null);
    apiKey.value = '';
    hasStoredKey.value = false;
    emit('save', null);
  }
};
</script>

<style scoped>
.modal-backdrop {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
